import React, { useState, useEffect } from 'react';
import './about-us.css';
import Aboutus_1 from '../../../assets/images/About_Us.jpeg';
import Aboutus_2 from '../../../assets/images/about_us_2.png';
import Instagram from '../../../assets/images/instagram 1.png';
import Linkedin from '../../../assets/images/linkedin 1.png';
import Twitter from '../../../assets/images/twitter 1.png';
import expertiseImage from '../../../assets/images/our_expertise_1.jpeg';
import expertiseImage1 from '../../../assets/images/Image No 2.png';
import expertiseImage2 from '../../../assets/images/Image No 1.png';
import expertiseIcon1 from '../../../assets/images/expertiseicon1.png';
import expertiseIcon2 from '../../../assets/images/expertiseicon2.png';
import expertiseIcon3 from '../../../assets/images/expertiseicon3.png';
import expertiseIcon4 from '../../../assets/images/expertiseicon4.png';
import Valueicon1 from '../../../assets/images/expertiseicon1.png';
import Valueicon2 from '../../../assets/images/expertiseicon2.png';
import Valueicon3 from '../../../assets/images/expertiseicon3.png';
import Valueicon4 from '../../../assets/images/expertiseicon4.png';
import { Link, useNavigate } from 'react-router-dom';

const expertiseData = {
  leadershipHiring: {
    title: 'Leadership Hiring',
    description:
      "With a decade of experience and deep industry expertise, Leaderly's founding team brings a fresh approach to leadership hiring. We seamlessly connect your organization with competent leaders, ensuring the right fit—fast.",
    content: 'Our expertise across industries ensures precise leadership matches. With deep market insights and advanced technology, we deliver a seamless, efficient, and results-driven hiring experience',
    image: expertiseImage,
  },
  diversityHiring: {
    title: 'Diversity Hiring',
    description:
      'Powered by cutting-edge technology, our platform streamlines the screening and shortlisting of senior candidates, saving you valuable time and effort.',
    content: 'We are committed to diversity hiring and leverage our AI-powered Advanced Search Customization to build a diverse and inclusive team of senior executives tailored to your organization’s needs.',
    image: expertiseImage1,
  },
  careerTransition: {
    title: 'Career Transition',
    description:
      'Invest in your most valuable asset—people. With Leaderly, build a leadership team that drives success.',
    content:
      'We provide specialised counselling and support services for senior leaders in customising and orchestrating their next career move.',
    image: expertiseImage2,
  },

};

const getExpertiseIcon = (index) => {
  switch (index) {
    case 1:
      return expertiseIcon1;
    case 2:
      return expertiseIcon2;
    case 3:
      return expertiseIcon3;

    default:
      return null;
  }
};

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState('leadershipHiring');
  const tabs = Object.keys(expertiseData);
  let currentIndex = tabs.indexOf(activeTab);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prevTab) => {
        const newIndex = (tabs.indexOf(prevTab) + 1) % tabs.length;
        return tabs[newIndex];
      });
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const { title, description, content, image } = expertiseData[activeTab];

  return (
    <div>
      <div className="fluid-container">
        <div className="aboutus-heading-container">
          <div className='aboutus-breadcrumb'>
            <span style={{
              color: '#FFFFFF', fontWeight: '600', textDecoration: 'none', marginRight: '50px'
            }}>
              <Link
                to={-1}
                style={{ color: '#FFFFFF', textDecoration: 'none' }}
                state={{ scrollPosition: location.state?.scrollPosition }}
              >
                Back
              </Link>
              <span style={{ marginLeft: '10px' }}> /</span>
              <span style={{ marginLeft: '10px' }}> About Us</span>
            </span>
          </div>
          <h2 className="aboutus-heading">Reinventing The Way Leadership Hiring Works</h2>
          <p className="aboutus-subheading">
            <span className='aboutus-subheading-span'>1<sup>st</sup></span> of its kind platform designed to upgrade your leadership hiring process
          </p>
        </div>

        <div className="aboutus-content-container">
          <div className="aboutus-left-content">
            <h3 className="aboutus-story-heading">Our Story</h3>
            <p className="aboutus-story-paragraph">
              Finding the right leaders for your organization is challenging. These obstacles have inspired us to seek a
              transformative solution.
            </p>
            <p className="aboutus-story-paragraph">
              Recognizing that incremental changes are insufficient, we have embarked on a journey with <span style={{ color: "#F35824" }}>Leaderly</span> to
              change the hiring landscape by harnessing technology as a powerful enabler.
            </p>
            <div className="aboutus-stats-container">
              <div className="aboutus-stat">
                <div className="aboutus-stat-number">5000+</div>
                <div className="aboutus-stat-content">Verified Leaders</div>
              </div>
              <div className="aboutus-stat-line"></div>
              <div className="aboutus-stat">
                <div className="aboutus-stat-number">130+</div>
                <div className="aboutus-stat-content">Trusted Companies</div>
              </div>
            </div>
          </div>
          <div className="aboutus-right-content">
            <img src={Aboutus_1} alt="office image" className="aboutus-image" />
          </div>
        </div>

        {/* <div className="team-container">
          <h2 className="team-heading">MEET THE TEAM</h2>
          <p className="team-subheading">
            Meet the dedicated team behind Leaderly, working diligently behind the scenes to bring it to life.
          </p>
          <div className="team-cards-container">
            <div className="team-card">
              <div className="team-member">
                <img src={Aboutus_2} alt="Team Member" className="aboutus-image_2" />
                <div className="team-member-info">
                  <h6 className="team-member-item">Executive Manager</h6>
                  <h6 className="team-member-name">Lucas Maik</h6>

                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt varius.</p>
                  <div className="team-member-social">
                    <img src={Instagram} alt="Team Member" className="instagram-icon" />
                    <img src={Linkedin} alt="Team Member" className="linkedin-icon" />
                    <img src={Twitter} alt="Team Member" className="twitter-icon" />
                  </div>
                </div>
              </div>
            </div>
            <div className="team-card">
              <div className="team-member">
                <img src={Aboutus_2} alt="Team Member" className="aboutus-image_2" />
                <div className="team-member-info">
                  <h6 className="team-member-item">Executive Manager</h6>
                  <h6 className="team-member-name">Lucas Maik</h6>

                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt varius.</p>
                  <div className="team-member-social">
                    <img src={Instagram} alt="Team Member" className="instagram-icon" />
                    <img src={Linkedin} alt="Team Member" className="linkedin-icon" />
                    <img src={Twitter} alt="Team Member" className="twitter-icon" />
                  </div>
                </div>
              </div>
            </div>
            <div className="team-card">
              <div className="team-member">
                <img src={Aboutus_2} alt="Team Member" className="aboutus-image_2" />
                <div className="team-member-info">
                  <h6 className="team-member-item">Executive Manager</h6>
                  <h6 className="team-member-name">Lucas Maik</h6>

                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt varius.</p>
                  <div className="team-member-social">
                    <img src={Instagram} alt="Team Member" className="instagram-icon" />
                    <img src={Linkedin} alt="Team Member" className="linkedin-icon" />
                    <img src={Twitter} alt="Team Member" className="twitter-icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="expertise-container">
          <h2>OUR EXPERTISE</h2>
          <div className="expertise-description">{description}</div>
          <div className="expertise-tabs">
            {tabs.map((key, index) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                <img src={getExpertiseIcon(index + 1)} alt={`Icon ${index + 1}`} className="tab-icon" />
                <span>{expertiseData[key].title}</span>
                <div className="underline"></div>
              </div>
            ))}
          </div>


          <div className="expertise-content">
            <div className="expertise-content-inner">
              <div className="expertise-text">
                <h3>{title}</h3>
                <p>{content}</p>
              </div>
              <img src={image} alt={title} className="expertise-image" />
            </div>
          </div>
        </div>

        <div className="our-values-container">
          <h2>OUR VALUES</h2>
          <p className="values-description">
            At Leaderly, we are committed to creating a positive impact through everything we do. Our values shape how we operate and define our approach to business, customers, and the community. Here's what we stand for:
          </p>
          <div className="values-cards">
            <div className="cardvalue">
              <div className="value-icon-container">
                <img src={Valueicon1} alt="value icon" className="value-icon" />
              </div>
              <h3>Customer-Centricity</h3>
              <p>Our customers are at the heart of everything we do. We aim to listen, understand, and respond to their needs with excellence and care.</p>
            </div>
            <div className="cardvalue">
              <div className="value-icon-container">
                <img src={Valueicon2} alt="value icon" className="value-icon" />
              </div>
              <h3>Excellence</h3>
              <p>We are committed to the highest standards, constantly refining our craft and pushing boundaries to deliver outstanding results.

              </p>
            </div>
            <div className="cardvalue">
              <div className="value-icon-container">
                <img src={Valueicon3} alt="value icon" className="value-icon" />
              </div>
              <h3>Trust</h3>
              <p>We act with integrity, transparency, and accountability, ensuring our customers and partners can rely on us. </p>
            </div>
            <div className="cardvalue">
              <div className="value-icon-container">
                <img src={Valueicon4} alt="value icon" className="value-icon" />
              </div>
              <h3>Respect</h3>
              <p>Through mutual respect, embracing diversity, listening with empathy, and treating everyone with dignity, we foster a culture of collaboration and inclusion.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
